export default {
    name: 'Auth',
    namespaced: true,
    state: {
        authName: "Wolfgang",
    },
}